import { createSelector } from 'reselect';
import { isDynamicListing } from '../../../selectors/dynamic-listing';

const getAllState = state => state;

export const getIsTicketPickerAdditive = createSelector(
  [getAllState],
  (allState) => {
    // if dynamic listing, the ticket picker uses additive behavior
    return isDynamicListing(allState);
  }
);
